import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Province} from './province.model'

@Injectable()
export class ProvinceSelectService {
  list: Observable<Province[]> = <Observable<Province[]>>this.http.get(
    '/api/provinces'
  ).shareReplay();

  constructor(private http: HttpClient) {
  }
}
